import type { Highlight } from '../types';

/**
 * Ключ геометрии для сравнения локальной failed-заметки с уже приехавшей с сервера.
 * Нужен, чтобы после офлайн→онлайн не держать дубликат UUID рядом с сохранённым `${id}-0`.
 */
export function highlightGeometryKey(h: Highlight): string {
    switch (h.type) {
        case 'text':
            return `text:${h.pageNumber}:${h.startOffset}:${h.endOffset}`;
        case 'positioned':
            return `pos:${h.pageNumber}:${h.x}:${h.y}`;
        case 'polygon':
            return `poly:${h.pageNumber}:${h.points.map((p) => `${p.x},${p.y}`).join(';')}`;
        case 'rect':
            return `rect:${h.pageNumber}:${h.x1},${h.y1},${h.x2},${h.y2}`;
        case 'none':
            return `none:${h.pageNumber}:${h.note ?? ''}`;
        default:
            return `id:${(h as Highlight).id}`;
    }
}

/** Оставить только те failed UUID, которых ещё нет среди серверных highlights. */
export function keepUnresolvedFailedHighlights(
    prev: Highlight[],
    fromServer: Highlight[],
): Highlight[] {
    const serverIds = new Set(fromServer.map((h) => h.id));
    const serverKeys = new Set(fromServer.map(highlightGeometryKey));
    return prev.filter((h) => {
        if (h.persistStatus !== 'failed') return false;
        if (/^\d+-\d+$/.test(h.id) || h.detail?.noteId != null) return false;
        if (serverIds.has(h.id)) return false;
        if (serverKeys.has(highlightGeometryKey(h))) return false;
        return true;
    });
}
